import type { SyncUltraStorageRequestDto, UltraStorageResponseDto } from '@poker-stats/contracts';
import request from '../../api/request/http-service';
import { SERVER_ADDRESSES } from '../../config/serverAddresses';

const CONTROLLER = 'ultra-huds';

export async function fetchUltraStorage(accessToken: string) {
  return request({
    server: SERVER_ADDRESSES.API,
    controller: CONTROLLER,
    requestMethod: 'GET',
    requestType: 'HTTP',
    api: true,
    accessToken,
    showApiCallSpinner: false,
  }) as Promise<UltraStorageResponseDto>;
}

export async function saveUltraStorage(accessToken: string, body: SyncUltraStorageRequestDto) {
  return request({
    server: SERVER_ADDRESSES.API,
    controller: CONTROLLER,
    requestMethod: 'PUT',
    requestType: 'HTTP',
    api: true,
    body,
    accessToken,
    showApiCallSpinner: false,
  }) as Promise<UltraStorageResponseDto>;
}
